import { SyntheticEvent, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getBrand, createBrand } from "../../redux/brandSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, TextField, ThemeProvider, createTheme } from "@mui/material";
import React from "react";
import { Brand } from "../../model/brand.model";
import { BrandsService } from "../../service/brands.service";
//import { isNumber } from "lodash";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import { CategoryService } from "../../service/categories.service";
import { ToastContainer, toast } from "react-toastify";


function CategoryDetails() {
  const params = useParams();
  const brandId = params.brandid;
  const dispatch = useDispatch();
  const { brand } = useSelector((state: any) => state.brandSlice);
  const navigate = useNavigate();

  const [status, setStatus] = React.useState(1);
  const [brandName, setBrandName] = React.useState("");
  const [selectedBrandId, setSelectedBrandId] = React.useState("select");
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const brandsService = new BrandsService();
  const categoryService = new CategoryService();


  const [catName, setcatName] = React.useState("");
  const [catImage, setcatImage] = React.useState("");
  const [catImageData, setcatImageData] = React.useState("");
  const [catId, setCatId] = React.useState("");
  const [errMsg, setErrMsg] = useState('');

  const [isedit, setIsEdit] = React.useState(true);

  const location = useLocation();
  let parameters = {}
  const loadAllBrands = () => {

    brandsService.brands(1).then(data => {
      const res = data.data;
      setAvailableBrands(res);

    });
  }

  let iscalled = false;
  useEffect(() => {
    //console.log("+++++++++++++++selectedBradId : " + selectedBrandId)
    if (!iscalled) {
      iscalled = true


      if (location != null && location.state != null && location.state.categoryDetails != null) {
        parameters = location.state.categoryDetails;

        console.log("params ", parameters)

        setcatName(location.state.categoryDetails.catName)
        setAvailableBrands(location.state.brandsData)
        setSelectedBrandId(location.state.categoryDetails.brandId)
        setcatImage(((location.state.categoryDetails.catImage).split("/").pop()))
        setStatus(location.state.categoryDetails.status)
        setCatId(location.state.categoryDetails.catId)
        setIsEdit(false)

      } else {
        loadAllBrands();
      }
    }
  }, []);

  const createNewCategory = () => {
    // dispatch(createBrand(brandName,status));

    if (selectedBrandId == "select") {
      return
    }

    const data = {
      "catId": catId,
      "brandId": Number(selectedBrandId),
      "catName": catName,
      "status": status,
      "catImage": catImage,
      "catImageData": catImageData
    };
    categoryService.createCategory(data).then((res: any) => {
      /*toast.success('Product created successfully', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate('../categories');
    }).catch((err: any) => {
      console.log('err ', err);
      setErrMsg('Something went wrong while creating the product');
    });*/
      if (res.status == '100') {

        toast.success("Updated Successfully !!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigate('../categories');
        }, 2100);

      } else {
        toast.error("No Data Available!!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigate('../categories');
        }, 2100);
      }
    })
  };

  const onUploadDispImg = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];
      console.log("^^^CatImg^^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setcatImage(file.name);
        setcatImageData(reader.result as string);
      }
      reader.onerror = (e) => { console.log('err') }
    }
  }

  const handleStatus = (event: React.ChangeEvent<HTMLInputElement>, value: Number) => {
    setStatus(Number(value));
  }

  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });
  return (
    <div className="App">
      <div className="border card p-0">
        <div className="border-bottom mt-3 col-md-12 row">
          <div className="col-4 form-group  text-left mt-4">
            <ThemeProvider theme={CustomFontTheme}>
              <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                className="form-control" name='brandId' defaultValue="select" value={selectedBrandId}
                disabled={!isedit}
                onChange={(e: any) => {
                  setSelectedBrandId(e.target.value);
                }}>
                <MenuItem style={{ fontSize: "small" }} disabled value="select" key="select">Select</MenuItem>
                {availableBrands.map((_el: any) => <MenuItem style={{ fontSize: "small" }} key={_el.brandId} value={_el.brandId}>{_el.brandName}</MenuItem>)}
              </TextField>
            </ThemeProvider>
          </div>
          <div className="col-md-4 text-left mt-4">
            <ThemeProvider theme={CustomFontTheme}>
              <TextField size="small" label="Main Category Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                type="text" className="form-control" name='prodDispName' value={catName}
                disabled={!isedit}
                onChange={(e: any) => {
                  setcatName(e.target.value);
                }} />
            </ThemeProvider>
          </div>
          <div className='col-md-4 text-left mb-3 mt-4 '>
            {/*<p style={{ color: "blue", fontSize: "16px" }} className='mb-2  font_size_13px text-right '>. jpg | . pdf file</p>*/}
            <ThemeProvider theme={CustomFontTheme}>

              <TextField size="small" label="Category Image ( . png Only )" id="outlined-start-adornment" inputProps={{ accept: "image/png" }}
                InputLabelProps={{ shrink: true }} variant="outlined" type="text"
                className="form-control" name='catIng' value={catImage}
                InputProps={{
                  sx: { height: 35 },
                  endAdornment: (
                    <IconButton component="label">
                      <FileUploadOutlinedIcon />
                      <input style={{ display: "none" }} accept="image/png,image/jpeg,image/jpg" type="file" hidden onChange={(event) => onUploadDispImg(event)} name="catImgHiddenImg" />
                    </IconButton>

                  ),
                }} />
            </ThemeProvider>
          </div>

          <div className="col-md-4 text-left">
            <div className="form-group"  >
              <label className="form-group mr-3 pt-2" > Status</label>
              <FormControl><RadioGroup row name='status' value={status}
                onChange={(e) => { setStatus(Number(e.target.value)) }} >
                <FormControlLabel value="1" label="Activate" control={<Radio size="small" color="success" />} />
                <FormControlLabel value="0" label="Deactive" control={<Radio size="small" color="error" />} />
              </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="card-footer col-12 text-center">
            <Button style={{ color: "green" }} className="mr-4" onClick={() => createNewCategory()} variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
              Submit
            </Button>
            <Button style={{ color: "red" }} className="ml-4" onClick={() => navigate('../categories')} variant="text" startIcon={<ClearOutlinedIcon />}>
              Cancel
            </Button>
          </div>
          <ToastContainer />
        </div>

      </div>

    </div>

  );
}

export default CategoryDetails;
